import { useMemo, useState } from "react";
import { hotUpdates, hotCategorys } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function HotUpdateList() {
  const [keyword, setKeyword] = useState("");
  const [active, setActive] = useState("全部");

  const list = useMemo(() => {
    const kw = keyword.trim();
    return hotUpdates.filter((item) => {
      const matchGroup = active === "全部" || item.category === active;
      const matchKw =
        kw === "" ||
        item.title.includes(kw) ||
        item.summary.includes(kw) ||
        item.group.includes(kw);
      return matchGroup && matchKw;
    });
  }, [keyword, active]);

  return (
    <section
      id="hot"
      className="bg-background-100 px-6 lg:px-10 py-14 md:py-20 border-y border-background-200 scroll-mt-24"
    >
      <SectionHeading
        index="02"
        label="Latest & Trending"
        title="热门视频更新列表"
        desc="标题加一句短摘要，直接把内容说清楚。列表按更新时间排，越靠前越新鲜。"
      />

      <div className="mt-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-wrap items-center gap-2">
          {hotCategorys.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => setActive(tag)}
              className={`px-3.5 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                active === tag
                  ? "bg-foreground-950 text-background-50"
                  : "bg-background-50 text-foreground-700 border border-background-300 hover:border-foreground-400"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="relative w-full lg:w-72">
          <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-[15px]"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索视频标题或关键词"
            className="w-full h-10 pl-10 pr-4 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
        </div>
      </div>

      <div className="mt-6 rounded-lg bg-background-50 border border-background-200 overflow-hidden">
        <div className="hidden md:flex items-center gap-4 px-5 py-3 bg-background-100 border-b border-background-200 text-[11px] font-label tracking-[0.14em] uppercase text-foreground-500">
          <span className="w-6">No.</span>
          <span className="flex-1">标题 / 短摘要</span>
          <span className="w-24">时长</span>
          <span className="w-24">热度</span>
          <span className="w-28">更新时间</span>
        </div>

        {list.length === 0 ? (
          <div className="px-5 py-14 text-center">
            <i className="ri-search-eye-line text-3xl text-foreground-300"></i>
            <p className="mt-3 text-sm text-foreground-500">
              没有匹配的条目，换个关键词试试。
            </p>
          </div>
        ) : (
          list.map((item, i) => (
            <a
              key={item.title}
              href="#index"
              className="grid grid-cols-1 md:grid-cols-[24px_1fr_96px_96px_112px] md:items-center gap-2 md:gap-4 px-5 py-4 border-b border-background-100 last:border-b-0 hover:bg-background-100 transition-colors cursor-pointer group"
            >
              <span className="hidden md:block font-label text-sm text-foreground-400">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0">
                <h5 className="text-sm md:text-[15px] font-medium text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h5>
                <p className="mt-1 text-xs md:text-[13px] text-foreground-600 leading-relaxed line-clamp-1">
                  {item.summary}
                </p>
              </div>
              <span className="hidden md:block text-xs text-foreground-500 font-label">
                {item.duration}
              </span>
              <span className="hidden md:inline-flex">
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-xs whitespace-nowrap">
                  {item.views}
                </span>
              </span>
              <span className="flex items-center justify-between md:justify-start gap-3 text-xs text-foreground-500">
                <span className="inline-flex md:hidden px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
                  {item.group}
                </span>
                <span className="whitespace-nowrap">{item.time}</span>
              </span>
            </a>
          ))
        )}
      </div>

      <p className="mt-4 text-xs text-foreground-500 flex items-center gap-1.5">
        <i className="ri-information-line"></i>
        列表仅作内容索引展示，点击条目会回到合集索引继续浏览。
      </p>
    </section>
  );
}